import React from 'react'

export default function index(props) {
  return (
    <div className="assessment1-container">
      <div className="assessment1-wrap">
        <div className="assessment1-title">
          Directions
        </div>
        <div className="assessment1-content direction-content">
          Have you ever changed your mind about what you’re going to order at a restaurant?  Your six guests are especially indecisive.  What’s more, they are adamant about changing the seating arrangement so that
        </div>
        <div className="assessment1-content direction-content">
          1.  Each guest is seated next to a guest ordering their second favorite dish
        </div>
        <div className="assessment1-content direction-content2">
          2.  No guest is sitting next to a guest eating their detested dish.
        </div>

        <div className="assessment1-content direction-content">
          You can forget about what you thought the guests liked and disliked when you read the specials.
        </div>

        <div className="assessment1-content direction-content">
          This exercise will change the guests’ preferences and test your pattern recognition abilities on the fly.
        </div>

        <div onClick={() => props.nextPage()} className="assessment1-start-btn">
          Get started
        </div>
      </div>
    </div>
  )
}
